// Interfaces
import { BaseApi } from 'api/base.api'
import {
  IUserAccessApi,
  IUserAccessApiGetListAttrs,
  IUserAccessApiListResponse,
  IUserAccessApiGetDetailAttrs,
  IUserAccessApiDetailResponse,
  IUserAccessApiRequest,
  IUserAccessApiUpdateAttrs,
  IUserAccessApiNullResponse,
} from 'interfaces/back-office/user-access/user-access-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class UserAccessApi extends BaseApi<IUserAccessApi> implements IUserAccessApiRequest {
  readonly url = ApiConstant.USER_ACCESS_URL
  private userAccessUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get user accesses
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IUserAccessApiGetListAttrs} payload
   *
   * @return {Promise<IUserAccessApiListResponse>} Promise<IUserAccessApiListResponse>
   */
  async userAccess_getList(payload: IUserAccessApiGetListAttrs): Promise<IUserAccessApiListResponse> {
    return this.POST(`${this.userAccessUrl}/list`, payload.body, { ...payload.requestConfig })
  }

  /**
   * @description Get user access
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IUserAccessApiGetDetailAttrs} payload
   *
   * @return {Promise<IUserAccessApiGDetailesponse>} Promise<IUserAccessApiDetailResponse>
   */
  async userAccess_getDetail(payload: IUserAccessApiGetDetailAttrs): Promise<IUserAccessApiDetailResponse> {
    return this.POST(`${this.userAccessUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Update access
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IUserAccessApiUpdateAttrs} payload
   *
   * @return {Promise<IUserAccessApiNullResponse>} Promise<IUserAccessApiNullResponse>
   */
  async userAccess_update(payload: IUserAccessApiUpdateAttrs): Promise<IUserAccessApiNullResponse> {
    return this.POST(`${this.userAccessUrl}/update/${payload.params.id}`, payload.body, {
      ...payload.requestConfig,
    })
  }
}
